import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Models
import IQuiz from 'models/Quiz';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import QuizTypes from 'types/QuizTypes';

const LeaderboardButton:FC = () => {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const isPollQuiz = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isScoringQuiz = [QuizTypes.Scoring, QuizTypes.Prediction].includes(quiz.type);

  const handleClick = () => {
    if (isPollQuiz) {
      navigateTo('results');
    } else {
      navigateTo('leaderboard');
    }
  }

  const label = quiz.callToAction.buttonTitle
    ? quiz.callToAction.buttonTitle
    : isPollQuiz
      ? t('buttons.results')
      : t('buttons.leaderboard')

  const isDisabled = !isPollQuiz && !result;

  if ( [QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type) ) return null;

  return (
    <div className={`z-10 text-center mb-4 ${isScoringQuiz ? 'order-1 mt-4' : ''}`}>
      <Button
        className={`
          w-full !text-xl primary-button
          ${isPollQuiz ? 'uppercase' : 'normal-case'}
        `}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {label}
      </Button>
    </div>
  )
}

export default LeaderboardButton;
